export default "__VITE_ASSET__C5u9OtSR__"